import HeroSection from "../../components/HeroSection/HeroSection"
import AboutSection from "../../components/AboutSection/AboutSection"
import ProductsSection from "../../components/ProductsSection/ProductsSection"
import NewsSection from "../../components/NewsSection/NewsSection"
import PartnersSection from "../../components/PartnersSection/PartnersSection"
import "./Home.css"
import ImageSliderSection from "../../components/ImageSliderSection/ImageSliderSection"

const Home = () => {
  return (
    <div className="home">
      <ImageSliderSection />
      {/* <HeroSection /> */}
      <ProductsSection />
      <AboutSection />
      <PartnersSection />
      {/* <NewsSection /> */}
    </div>
  )
}

export default Home
